<mat-dialog-content style="margin: -28px; padding: 0; max-height: unset;">
  <div style="min-height: 640px;">
    <iframe #iframe *ngIf="iFrameUrl" [src]="iFrameUrl | safe: 'resourceUrl'"
      style="height:inherit;width:100%;margin:0;padding:0;min-height: 640px;border:none; overflow: hidden;"
      name="poliframe" id="poliframe"></iframe>
  </div>
</mat-dialog-content>